import { useState } from "react";
import { X, AlertTriangle } from "lucide-react";
import { Button } from "./ui/button";

const AgeGate = ({ onVerify }) => {
  const [declined, setDeclined] = useState(false);

  if (declined) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-monaco-bg-0">
        <div className="text-center p-8">
          <AlertTriangle className="w-16 h-16 text-monaco-red mx-auto mb-4" />
          <h2 className="font-display text-2xl text-monaco-text-0 mb-2">
            Zugang verweigert
          </h2>
          <p className="text-monaco-text-1 mb-6">
            Diese Website ist nur für Personen ab 18 Jahren zugänglich.
          </p>
          <Button
            onClick={() => window.location.href = "https://google.com"}
            variant="outline"
            className="border-monaco-text-2 text-monaco-text-1 hover:bg-monaco-bg-2"
          >
            Seite verlassen
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{
        background: "linear-gradient(180deg, rgba(7,7,10,0.98) 0%, rgba(7,7,10,0.95) 100%)",
        backdropFilter: "blur(20px)"
      }}
      data-testid="age-gate-modal"
    >
      <div 
        className="relative w-full max-w-md mx-4 p-8 rounded-xl"
        style={{
          background: "linear-gradient(145deg, rgba(13,13,18,0.9) 0%, rgba(18,18,26,0.9) 100%)",
          border: "1px solid rgba(255, 27, 61, 0.3)",
          boxShadow: "0 0 60px rgba(255, 27, 61, 0.15)"
        }}
      >
        {/* Logo/Brand */}
        <div className="text-center mb-8">
          <h1 className="font-display text-4xl italic text-monaco-text-0 mb-2">
            Monaco Bar
          </h1>
          <div className="w-16 h-0.5 bg-monaco-red mx-auto" />
        </div>

        {/* Age Warning */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-monaco-red/10 border-2 border-monaco-red mb-4">
            <span className="font-display text-3xl text-monaco-red font-bold">18+</span>
          </div>
          <h2 className="text-xl text-monaco-text-0 mb-3">
            Altersbeschränkung
          </h2>
          <p className="text-monaco-text-1 text-sm leading-relaxed">
            Diese Website enthält Inhalte, die nur für Erwachsene (18+) bestimmt sind.
            Mit dem Betreten bestätigen Sie, dass Sie mindestens 18 Jahre alt sind.
          </p>
        </div>

        {/* Legal Notice */}
        <div className="bg-monaco-bg-0/50 rounded-lg p-4 mb-6 text-xs text-monaco-text-2">
          <p>
            Durch Klicken auf "Eintreten" bestätigen Sie, dass Sie die gesetzlichen
            Anforderungen für den Zugang zu dieser Website erfüllen und unsere{" "}
            <a href="/datenschutz" className="text-monaco-red hover:underline">
              Datenschutzbestimmungen
            </a>{" "}
            akzeptieren.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex gap-4">
          <Button
            onClick={() => setDeclined(true)}
            variant="outline"
            className="flex-1 h-12 border-monaco-text-2/30 text-monaco-text-1 hover:bg-monaco-bg-2 hover:border-monaco-text-2"
            data-testid="age-gate-decline"
          >
            Verlassen
          </Button>
          <Button
            onClick={onVerify}
            className="flex-1 h-12 bg-monaco-red hover:bg-monaco-red-hover text-white btn-shine neon-glow-hover relative overflow-hidden"
            data-testid="age-gate-confirm"
          >
            Ich bin 18+
          </Button>
        </div>

        {/* Cookie Notice */}
        <p className="text-center text-xs text-monaco-text-2 mt-4">
          Wir verwenden localStorage für Favoriten und Altersverifikation.
        </p>
      </div>
    </div>
  );
};

export default AgeGate;
